/*
 * Rabatt-Anzeige · Sicherheitsnetz für das Aktionsende
 * ---------------------------------------------------------------------------
 * Elemente mit data-rabatt-ende (Unix-Zeit in Sekunden) zeigen einen
 * Rabatt-Streichpreis. Ist das Aktionsende erreicht, ersetzt dieses Skript den
 * Inhalt durch den Normalpreis aus <template data-rabatt-fallback>; Elemente
 * ohne Fallback (z. B. der Hinweistext) werden ausgeblendet.
 *
 * Warum: Seiten können aus dem Cache kommen und der Flow-Abgleich läuft nur
 * alle paar Minuten. So steht nach Aktionsende nie ein Preis da, den der
 * Checkout nicht mehr gewährt. Greift auch bei nachgeladenen Inhalten
 * (Schnellansicht, Variantenwechsel, Filter, Paginierung) und bei offenen Tabs.
 */
(function () {
  'use strict';

  function aufraeumen() {
    var jetzt = Date.now() / 1000;
    var elemente = document.querySelectorAll('[data-rabatt-ende]');

    for (var i = 0; i < elemente.length; i++) {
      var el = elemente[i];
      var ende = parseInt(el.getAttribute('data-rabatt-ende'), 10);
      if (!ende || jetzt < ende) continue;

      var fallback = null;
      for (var c = 0; c < el.children.length; c++) {
        if (el.children[c].matches('template[data-rabatt-fallback]')) {
          fallback = el.children[c];
          break;
        }
      }

      el.removeAttribute('data-rabatt-ende');
      if (fallback) {
        el.replaceChildren(fallback.content.cloneNode(true));
      } else {
        el.replaceChildren();
        el.hidden = true;
      }
    }
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(function () {
      geplant = false;
      aufraeumen();
    });
  }

  function starten() {
    aufraeumen();
    new MutationObserver(planen).observe(document.body, { childList: true, subtree: true });
    window.setInterval(aufraeumen, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
